import React from "react";

const ModalShell = ({ eyebrow, title, subtitle, onClose, onSubmit, saving, submitText, children, size = "lg" }) => (
  <div className="cash-bank-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className={`cash-bank-modal cash-bank-modal-${size}`} role="dialog" aria-modal="true" aria-label={title}>
      <form onSubmit={onSubmit} noValidate>
        <header className="cash-bank-modal-header">
          <div>
            {eyebrow ? <div className="cash-bank-eyebrow">{eyebrow}</div> : null}
            <h3>{title}</h3>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          <button className="btn-close" type="button" onClick={onClose} aria-label="Tutup" />
        </header>
        <main className="cash-bank-modal-body">{children}</main>
        <footer className="cash-bank-modal-footer">
          <button type="button" className="btn" onClick={onClose} disabled={saving}>{submitText ? "Batal" : "Tutup"}</button>
          {submitText ? (
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? <span className="spinner-border spinner-border-sm me-2" role="status" /> : null}
              {saving ? "Memproses..." : submitText}
            </button>
          ) : null}
        </footer>
      </form>
    </section>
  </div>
);

export default ModalShell;
